import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import Select from "react-select";

import { StyleHelper } from "utils";
import useQueryParams from "hooks/useQueryParams";
import useExceptionHandler from "hooks/useExceptionHandler";
import useMessage from "hooks/useMessage";
import { AprobacionComercialManager as manager } from "managers";
import { ComprobanteRecibidoLookup } from "components";
import RadioGroup from "components/RadioGroup/RadioGroup";
import EditHeader from "components/PantallasEdit/Header/EditHeader";
import EditContainer from "components/PantallasEdit/EditContainer/EditContainer";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import EditSection from "components/PantallasEdit/EditSection/EditSection";

export default function AprobacionComercialEdit({ showLoading, hideLoading }) {
  const [aprobacion, setAprobacion] = useState({});
  const [saved, setSaved] = useState(false);

  const URLParameters = useQueryParams();
  const { handleException } = useExceptionHandler();
  const { Message, cerrarAlertas, Types } = useMessage();

  const comprobanteRecibidoId = URLParameters.get("ComprobanteRecibidoId");

  const ESTADO_RECHAZADO = 2;

  const ESTADO_LIST = [
    { value: 1, label: "Aprobado" },
    { value: ESTADO_RECHAZADO, label: "Rechazado" },
  ];

  useEffect(() => {
    if (comprobanteRecibidoId) {
      setAprobacion({
        ...aprobacion,
        ComprobanteElectronicoRecibidoIdSec: comprobanteRecibidoId,
      });
    }

    return () => {
      cerrarAlertas();
      hideLoading();
    };
  }, []);


  function grabar() {
    if (!saved) {
      showLoading();
      manager
        .crear(aprobacion)
        .then((res) => {
          Message({
            message:
              res.RespuestaAprobacionComercial?.Mensaje?.string ??
              `Grabado Exitosamente`,
          });
          setSaved(true);
        })
        .catch((e) => handleException(e))
        .finally(() => hideLoading());
    } else {
      Message({
        message: `La entidad ya fue grabada.`,
        type: Types.TYPE_WARNING,
      });
    }
  }

  return (
    <Form action="" className="form-horizontal" method="">
      <Card>
        <EditHeader
          titulo="Aprobación Comercial"
          grabar={grabar}
          volver={true}
        />
        <EditContainer>
          <EditSection>
            <SectionRow columns={4}>
              <InputContainer stacked label="Documento">
                <ComprobanteRecibidoLookup
                  required={true}
                  initialValue={{
                    value: aprobacion.ComprobanteElectronicoRecibidoIdSec,
                  }}
                  onChange={(e) => {
                    setAprobacion({
                      ...aprobacion,
                      TipoeCF: e.tipoeCF,
                      eNCF: e.eNCF,
                      NombreComercial: e.nombreComercial,
                      MontoTotal: e.monto,
                      FechaEmision: e.fechaEmision,
                      RNCEmisor: e.rncEmisor,
                      ComprobanteElectronicoRecibidoIdSec: e.ComprobanteElectronicoRecibidoIdSec,
                    });
                  }}
                />
              </InputContainer>

              <InputContainer stacked label="Estado">
                <RadioGroup
                  name="Estado"
                  options={ESTADO_LIST}
                  selectedOption={aprobacion.Estado}
                  onChange={(e) => {
                    setAprobacion({
                      ...aprobacion,
                      Estado: e.target.value
                    })
                  }}
                />
              </InputContainer>

              {aprobacion.Estado == ESTADO_RECHAZADO && (
                <InputContainer stacked label="Motivo Rechazo">
                  <Form.Control
                    name="DetalleMotivoRechazo"
                    type="text"
                    as={"textarea"}
                    rows={2}
                    value={aprobacion.DetalleMotivoRechazo}
                    onChange={(e) => {
                      setAprobacion({
                        ...aprobacion,
                        DetalleMotivoRechazo: e.target.value,
                      });
                    }}
                    style={StyleHelper.InputRequired}
                  />
                </InputContainer>
              )}
            </SectionRow>
          </EditSection>
        </EditContainer>
      </Card>
    </Form>
  );
}
